var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3708 51.6804C62.4651 56.0844 74.0436 54.0844 80.2934 48.1762C88.2399 40.6561 87.4092 27.6429 78.4405 19.1618C69.4719 10.6806 55.7067 9.89604 47.7612 17.4096C41.5105 23.3234 39.3945 34.2688 44.0555 42.8715L12.25 72.9445L13.2211 73.8637L21.5652 81.7543L30.1097 89.8333L37.0969 83.226L28.5563 75.1469L33.2144 70.7429L41.755 78.822L48.7412 72.2147L40.2016 64.1347L53.3708 51.6804ZM55.1726 24.4246C59.0393 20.7681 66.1364 21.5462 71.0263 26.1702C75.919 30.7998 76.7458 37.5103 72.8791 41.1668C69.0124 44.8177 60.2696 45.5958 55.3807 40.9727C50.4889 36.3487 51.3059 28.0746 55.1726 24.4246Z",
    fill: "#86AA63"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/key.ebe4645d805d45b7584c06ca1c1237fa.svg";